import './ChainConnector.css';

export const ChainConnector = () => {
  return (
    <div className="chain-connector">
      <img
        src="/chain.svg"
        className="chain-svg"
        alt=""
        aria-hidden="true"
      />
    </div>
  );
};
